export default __webpack_public_path__ + "static/media/cheque.f4a97e3e.svg";